export const DISCOVER_SOURCE_QUERY_PARAM = 'discover';
export const QUERY_PARAMS_KEYS = {
  PAGE: 'p',
  QUANTITY: 'quantity',
  SEARCH: 'q',
  SOURCE: 'source',
  VARIANT_ID: 'id',
};
